"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Transition = _interopRequireDefault(require("react-transition-group/Transition"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var _theme = _interopRequireDefault(require("../../theme"));

var _util = require("../../theme/util");

var _Box = _interopRequireDefault(require("../Box"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _Portal = _interopRequireDefault(require("../Portal"));

var _preventBodyScroll = _interopRequireDefault(require("./preventBodyScroll"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIMEOUT = 250;
var enteringAnim = (0, _styledComponents.keyframes)(["0%{opacity:0;}100%{opacity:0.5;}"]);
var exitingAnim = (0, _styledComponents.keyframes)(["0%{opacity:0.5;}100%{opacity:0;}"]);
var Mask = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Overlay__Mask",
  componentId: "sc-2x9fs4-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;overflow:auto;z-index:", ";&:before{content:' ';opacity:0.5;background-color:", ";position:fixed;top:0;left:0;width:100%;height:100%;}&[data-transition=entering]:before,&[data-transition=entered]:before{animation:", " ", "ms ", " both;}&[data-transition=exiting]:before,&[data-transition=exited]:before{animation:", " ", "ms ", " both;}"], function (props) {
  return props.zIndex || 'auto';
}, (0, _themeGet["default"])('colors.neutral.700'), enteringAnim, TIMEOUT, _util.transition, exitingAnim, TIMEOUT, _util.transition);

var Overlay =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props) {
    var _this;

    _classCallCheck(this, Overlay);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Overlay).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "preventBodyScroll", function (prevent) {
      if (_this.props.preventBodyScroll) {
        (0, _preventBodyScroll["default"])(prevent);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMaskMouseDown", function () {
      _this.moved = false;
    });

    _defineProperty(_assertThisInitialized(_this), "onMaskMouseMove", function () {
      _this.moved = true;
    });

    _defineProperty(_assertThisInitialized(_this), "onMaskMouseUp", function (e) {
      if (_this.moved || e.target !== e.currentTarget || !_this.props.shouldCloseOnClick) {
        return;
      }

      _this.close();
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      if (_this.props.onBeforeClose && _this.props.onBeforeClose() === false) {
        return;
      }

      _this.setState({
        exiting: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnter", function () {
      _this.preventBodyScroll(true);

      _this.props.onEnter();
    });

    _defineProperty(_assertThisInitialized(_this), "handleEntering", function () {
      _this.props.onEntering();
    });

    _defineProperty(_assertThisInitialized(_this), "handleEntered", function () {
      _this.props.onEntered();
    });

    _defineProperty(_assertThisInitialized(_this), "handleExit", function () {
      // console.info('Overlay - exit')
      _this.props.onExit();
    });

    _defineProperty(_assertThisInitialized(_this), "handleExiting", function () {
      // console.info('Overlay - exiting')
      _this.props.onExiting();
    });

    _defineProperty(_assertThisInitialized(_this), "handleExited", function () {
      // console.info('Overlay - exited')
      _this.preventBodyScroll(false);

      _this.setState({
        exited: true,
        exiting: false
      });

      _this.props.onExited();
    });

    _this.state = {
      exiting: false,
      exited: !props.shown
    };
    return _this;
  }

  _createClass(Overlay, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.shown && this.props.shown) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          exited: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.preventBodyScroll(false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          shown = _this$props.shown,
          zIndexProp = _this$props.zIndex,
          rest = _objectWithoutProperties(_this$props, ["children", "shown", "zIndex"]);

      var _this$state = this.state,
          exiting = _this$state.exiting,
          exited = _this$state.exited;
      if (exited) return null;
      return _react["default"].createElement(_Stack["default"], {
        value: zIndexProp || _Stack["default"].constants.OVERLAY
      }, function (zIndex) {
        return _react["default"].createElement(_Portal["default"], null, _react["default"].createElement(_Transition["default"], {
          appear: true,
          unmountOnExit: true,
          "in": shown && !exiting,
          timeout: TIMEOUT,
          onExit: _this2.handleExit,
          onExiting: _this2.handleExiting,
          onExited: _this2.handleExited,
          onEnter: _this2.handleEnter,
          onEntering: _this2.handleEntering,
          onEntered: _this2.handleEntered
        }, function (state) {
          return _react["default"].createElement(Mask, _extends({
            "data-transition": state,
            onMouseDown: _this2.onMaskMouseDown,
            onMouseMove: _this2.onMaskMouseMove,
            onMouseUp: _this2.onMaskMouseUp,
            zIndex: zIndex,
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center"
          }, rest), typeof children === 'function' ? children({
            state: state,
            close: _this2.close
          }) : children);
        }));
      });
    }
  }]);

  return Overlay;
}(_react["default"].Component);

exports["default"] = Overlay;

_defineProperty(Overlay, "propTypes", {
  onBeforeClose: _propTypes["default"].func,
  preventBodyScroll: _propTypes["default"].bool,
  shouldCloseOnClick: _propTypes["default"].bool,
  shown: _propTypes["default"].bool.isRequired
});

_defineProperty(Overlay, "defaultProps", {
  preventBodyScroll: false,
  shouldCloseOnClick: true,
  theme: _theme["default"],
  onExit: function onExit() {},
  onExiting: function onExiting() {},
  onExited: function onExited() {},
  onEnter: function onEnter() {},
  onEntering: function onEntering() {},
  onEntered: function onEntered() {}
});